import React from 'react';
import { connect } from 'react-redux';

class SpecialItemInformation extends React.Component {

    render() {

        return (
            <div>
                {(this.props.item && this.props.item[this.props.type] && this.props.item[this.props.type].item_image != null) && <img
                    src={this.props.assets_url + this.props.item[this.props.type].item_image}
                    className="menu-item-header-image"
                />}
                {(!this.props.item || !this.props.item.app_view_image) && <div className="menu-item-empty-image" />}

                <div className="menu-item-information-window">
                    <div>
                        {(this.props.isCustomPizza) ? <p className="menu-item-name">Build Your Own Pizza.</p> : <p className="menu-item-name">{this.props.item.display_name}</p>}
                    </div>

                    <div>
                        {(!this.props.isCustomPizza && this.props.item[this.props.type] && this.props.item[this.props.type].description != null) && <p className="menu-item-description">{this.props.item[this.props.type].description}</p>}
                        {(this.props.isCustomPizza) && <p className="menu-item-description">Add your toppings and you're good to go!</p>}
                    </div>
                </div>
            </div>
        );
    }
};

const mapStateToProps = (state) => {

    return {
        assets_url: state.currentLocation.info.assets_url,
    };
};

export default connect(mapStateToProps)(SpecialItemInformation);